export const createMistEffect = (effectLayer, settings) => {
  try {
    const canvas = document.createElement('canvas');
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    effectLayer.appendChild(canvas);

    const particles = [];
    const particleCount = settings.intensity;
    const maxVelocity = 2;
    const targetFPS = 33;

    const canvasWidth = effectLayer.getBoundingClientRect().width;
    const canvasHeight = effectLayer.getBoundingClientRect().height;

    const imageObj = new Image();
    imageObj.onload = () => {
      particles.forEach(particle => particle.setImage(imageObj));
    };
    imageObj.src = 'https://c.servedbyivo.com/mist.png';

    class Particle {
      constructor(context) {
        this.x = 0;
        this.y = 0;
        this.xVelocity = 0;
        this.yVelocity = 0;

        this.radius = 5;
        this.context = context;
      }

      draw = () => {
        if (this.image) {
          this.context.drawImage(this.image, this.x - 128, this.y - 128);
          return;
        }
        this.context.beginPath();
        this.context.arc(this.x, this.y, this.radius, 0, 2 * Math.PI, false);
        this.context.fillStyle = 'rgba(255, 255, 255, 0)';
        this.context.fill();
        this.context.closePath();
      };

      update = () => {
        this.x += this.xVelocity;
        this.y += this.yVelocity;

        if (this.x >= canvasWidth) {
          this.xVelocity = -this.xVelocity;
          this.x = canvasWidth;
        } else if (this.x <= 0) {
          this.xVelocity = -this.xVelocity;
          this.x = 0;
        }

        if (this.y >= canvasHeight) {
          this.yVelocity = -this.yVelocity;
          this.y = canvasHeight;
        } else if (this.y <= 0) {
          this.yVelocity = -this.yVelocity;
          this.y = 0;
        }
      };

      setPosition = (x, y) => {
        this.x = x;
        this.y = y;
      };

      setVelocity = (x, y) => {
        this.xVelocity = x;
        this.yVelocity = y;
      };

      setImage = image => (this.image = image);
    }

    const generateRandom = (min, max) => (Math.random() * (max - min) + min);

    // The canvas context if it is defined.
    let context;

    // Initialise the scene and set the context if possible
    const init = () => {
      if (canvas.getContext) {
        context = canvas.getContext('2d');
        for (let i = 0; i < particleCount; i += 1) {
          const particle = new Particle(context);
          particle.setPosition(generateRandom(0, canvasWidth), generateRandom(0, canvasHeight));
          particle.setVelocity(generateRandom(-maxVelocity, maxVelocity), generateRandom(-maxVelocity, maxVelocity));
          particles.push(particle);
        }
      }
    };

    const draw = () => {
      context.clearRect(0, 0, canvasWidth, canvasHeight);
      particles.forEach((particle) => {
        particle.draw();
      });
    };

    const update = () => {
      particles.forEach((particle) => {
        particle.update();
      });
    };

    init();

    if (context) {
      setInterval(() => {
        update();
        draw();
      }, 1000 / targetFPS);
    }
  } catch (e) {
    console.log(e);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/effects/mist.js